import React from "react";
import { useDispatch } from "react-redux";
import { playSong } from "../../common/actions/common.actions";
import { useTranslation } from "react-i18next";
import { RiDeleteBin6Line } from "react-icons/ri";
import { FaDownLong, FaUpLong } from "react-icons/fa6";
import { MdOutlineSportsSoccer } from "react-icons/md";

const Card = ({
    number,
    team1,
    team2,
    odd,
    choosen,
    handleRemoveCard,
    match,
    normalColor = true,
}) => {
    const dispatch = useDispatch();
    const { i18n } = useTranslation();

    const homeTeamName = i18n.language === "en" ? team1 : match.homeTeamMyan;
    const awayTeamName = i18n.language === "en" ? team2 : match.awayTeamMyan;
    const selectedLabel =
        choosen === "home"
            ? homeTeamName
            : choosen === "away"
                ? awayTeamName
                : choosen === "over"
                    ? "Over"
                    : choosen === "under"
                        ? "Under"
                        : choosen;
    const selectionAccent = normalColor
        ? "border-emerald-400/50 bg-emerald-50 text-emerald-700"
        : "border-amber-400/60 bg-amber-50 text-amber-700";

    const handleSongClick = async () => {
        dispatch(playSong());
    };

    const removeCard = () => {
        handleSongClick();
        handleRemoveCard(match.rapidEventId);
    };

    return (
        <div className="rounded-md border border-white/70 bg-white/90 p-2 transition-all duration-300">
            <div className="flex items-start justify-between gap-3">
                <div className="flex items-center gap-3">
                    <div className="flex h-8 w-8 items-center justify-center rounded-md bg-gradient-to-br from-crimson via-red-primary to-crimson text-sm font-bold text-white shadow-lg">
                        {number}
                    </div>

                    <div className="space-y-1">
                        <div className="text-sm font-semibold leading-5 text-blue-primary">
                            <p>{homeTeamName}</p>
                            <p className="text-blue-primary/65">{awayTeamName}</p>
                        </div>
                    </div>
                </div>

                <button
                    type="button"
                    onClick={removeCard}
                    className="flex h-8 w-8 items-center justify-center rounded-md border border-red-200 bg-red-50 text-red-500 transition-all duration-300 hover:border-red-300 hover:bg-red-100"
                    aria-label="Remove match"
                >
                    <RiDeleteBin6Line size={18} />
                </button>
            </div>

            <div className="mt-2 grid grid-cols-[minmax(0,1fr)_auto] gap-1">
                <div className={`rounded-md border px-2 py-2 ${selectionAccent}`}>
                    <div className="flex justify-between items-center text-sm font-bold">
                        <div className="flex gap-2 items-center">
                            {(choosen === "over" || choosen === "under") && (
                                <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-white">
                                    {choosen === "over" ? <FaUpLong size={12} /> : <FaDownLong size={12} />}
                                </span>
                            )}
                            <span>
                                {choosen === "over"
                                    ? `${homeTeamName} ${selectedLabel}`
                                    : choosen === "under"
                                        ? `${awayTeamName} ${selectedLabel}`
                                        : selectedLabel}
                            </span>
                        </div>

                        <p className="font-bold leading-none bg-slate-500 px-2 py-1 rounded-md text-white">{odd}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Card;
